const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20content%20showcase%20with%20warm%20golden%20lighting%2C%20artistic%20editorial%20style%2C%20sophisticated%20composition%2C%20soft%20shadows%2C%20clean%20minimal%20background%2C%20premium%20visual%20aesthetic&width=800&height=500&seq=media-01&orientation=landscape',
    title: '探花精选特辑：七月最佳内容回顾',
    duration: '15:42',
    views: '8.5k',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20editorial%20showcase%2C%20artistic%20visual%20storytelling%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20clean%20background%2C%20sophisticated%20premium%20aesthetic&width=800&height=500&seq=media-02&orientation=landscape',
    title: '探花一区「新人大赏」内容盘点',
    duration: '12:18',
    views: '6.9k',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20visual%20collection%20display%20with%20warm%20amber%20lighting%2C%20editorial%20design%2C%20soft%20gradients%2C%20clean%20minimal%20background%2C%20sophisticated%20showcase%2C%20premium%20aesthetic&width=800&height=500&seq=media-03&orientation=landscape',
    title: '探花大神经典系列全解析',
    duration: '20:05',
    views: '11.2k',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20visual%20showcase%2C%20elegant%20editorial%20style%2C%20soft%20golden%20lighting%2C%20sophisticated%20composition%2C%20clean%20background%2C%20premium%20artistic%20aesthetic&width=800&height=500&seq=media-04&orientation=landscape',
    title: '探花91社区本周热门内容速览',
    duration: '08:56',
    views: '5.3k',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-play-circle-line"></i>
            精彩内容
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            内容精选展映
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            探花系列平台编辑团队精心策划的内容专题展映
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-2 right-2 flex items-center gap-1.5 bg-background-950/70 backdrop-blur-sm text-background-50 text-[10px] font-medium px-2 py-1 rounded">
                  <i className="ri-play-fill"></i>
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 bg-background-50/90 backdrop-blur-sm text-[10px] font-medium text-foreground-700 px-2 py-1 rounded-full">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}